import { z } from 'zod';

export const CoreBillingTransactionScalarFieldEnumSchema = z.enum(['id','cityId','createdAt','updatedAt','deactivatedAt','serviceItem','amount','status','type','description','transactionDate','serviceDate','quantity','rate','referenceNumber','accountId']);

export default CoreBillingTransactionScalarFieldEnumSchema;
